import angular from 'angular';
import ourPartnersComponent from './ourpartners.component';
const sponsorPortalModule = angular.module('com.module.sponsor-portal', []);
sponsorPortalModule.component('ourPartners', ourPartnersComponent);
export default sponsorPortalModule;



// WEBPACK FOOTER //
// ./js/containers/sponsorPortal/index.js